import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, } from 'react';
import { useFeatureFlagService } from '../hooks/useFeatureFlagService';
var FeatureFlagContext = createContext({
    checkFlag: function () { return false; },
    loading: false,
    error: null,
});
export var FeatureFlagProvider = function (_a) {
    var children = _a.children, featureFlagUrl = _a.featureFlagUrl, tenantId = _a.tenantId, accessToken = _a.accessToken, onError = _a.onError;
    var _b = useFeatureFlagService(featureFlagUrl, accessToken, tenantId), flags = _b.data, loading = _b.loading, error = _b.error;
    var contextValue = useMemo(function () { return ({
        checkFlag: function (flag, defaultValue) {
            if (defaultValue === void 0) { defaultValue = false; }
            if (loading || flags === null) {
                return defaultValue;
            }
            if (error ||
                !flags ||
                typeof flags !== 'object' ||
                typeof flags[flag] !== 'boolean') {
                if (onError) {
                    onError(
                    // eslint-disable-next-line max-len
                    "Problem checking feature flag ".concat(flag, " with tenantId ").concat(tenantId, " and accessToken exists ").concat(!!accessToken, ": ").concat(error));
                }
                return defaultValue;
            }
            return flags[flag];
        },
        loading: loading,
        error: error,
    }); }, [flags, loading, error, onError, accessToken, tenantId]);
    return (_jsx(FeatureFlagContext.Provider, { value: contextValue, children: children }));
};
export var useFeatureFlags = function () {
    var context = useContext(FeatureFlagContext);
    if (context === undefined) {
        throw new Error('useFeatureFlags must be used within a FeatureFlagProvider');
    }
    return context;
};
